export const licenseTypeOptions = [
  { label: 'Agent', value: 'AGENT' },
  { label: 'Agency', value: 'AGENCY' }
];

export const calendarLabels = {
  calendarAriaLabel: 'Calendar',
  nextMonth: 'Next Month',
  prevMonth: 'Previous Month',
  textBoxAriaLabel: 'Calendar text box',
  toggleAriaLabel: 'Open/Close Calendar',
  togglePicker: 'Date picker toggle',
  dateFormat: 'DD-MM-YYYY',
  effectiveDate: 'Effective date',
  screeningEffectiveDate: 'Screening effective date (if applicable)',
  expiredDate: 'Expiry date'
};

export const formLabels = {
  licenseNumber: 'License number',
  screeningStatus: 'Screening status (if applicable)',
  licensedProvince: 'Province or territory',
  organizationCode: 'Agency name/branch',
  organizationName: 'Agency name',
  name: 'Name',
  licenseType: 'License type',
  profileRef: 'Agent name',
  legalName: 'Legal name',
  status: 'Status',
  effectiveDate: 'Effective date',
  screeningEffectiveDate: 'Screening effective date (if applicable)',
  expiredDate: 'Expiry date',
  agencyName: 'Agency name',
  agencyCode: 'Agency code',
  agencyContactEmail: 'Licensing email',
  agentFirstName: 'Agent first name',
  agentLastName: 'Agent last name',
  title: 'Title',
  role: 'Role',
  accessType: 'Access type',
  language: 'Preferred language',
  email: 'Email',
  city: 'City or town',
  province: 'Province or territory',
  country: 'Country'
};

export const fieldLabels = { calendarLabels, formLabels, datePickerLabels: calendarLabels };

export const MIN_DATE = new Date('1990-01-01T00:00:00.000Z');
export const dateTimeFormat = 'YYYY-MM-DDT10:00:00.000Z';
export const futureDate = '01-01-9999';

export const screeningStatusOptions = [
  {
    label: 'Approved',
    value: 'APPROVED'
  },
  {
    label: 'Declined',
    value: 'DECLINED'
  },
  {
    label: 'In progress',
    value: 'IN_PROGRESS'
  },
  {
    label: 'N/A',
    value: 'NA'
  }
];

export const statusOptions = [
  {
    label: 'Pending renewal',
    value: 'RENEWAL_PENDING'
  },
  {
    label: 'In progress',
    value: 'IN_PROGRESS'
  },
  {
    label: 'Authorized',
    value: 'AUTHORIZED'
  },
  {
    label: 'Not authorized',
    value: 'NOT_AUTHORIZED'
  }
];

export const formErrors = {
  agencyRequired: 'Enter agency name',
  agentNameRequired: 'Enter an agent',
  licenseNumberRequired: 'Enter license number',
  legalNameRequired: 'Enter legal name',
  provinceRequired: 'Select province or territory',
  effectiveDateRequired: 'Enter effective date',
  expiryDateRequired: 'Enter expiry date',
  statusRequired: 'Select status',
  effectiveDateInvalid: 'Effective date is invalid',
  expiredDateInvalid: 'Expiry date is invalid',
  screeningEffectiveDateInvalid: 'Screening effective date is invalid',
  expiredDateFutureDtValid: 'Expiry date can not be less than effective date',
  effectiveDateFutureDtValid: 'Effective date can not be greater than expiry date',
  agentNameValidation: 'You must choose an agency before you select an agent',
  agentNameValidationMsg: 'Enter a valid agent',
  agencyNameValidationMsg: 'Enter a valid agency name',
};
